export default __webpack_public_path__ + "static/media/cart.da7ca7dc.svg";